import React from 'react';
import { isMacOS } from './../../utils/isMacOS';
import { isFirefox } from './../../utils/isFirefox';
import { useTheme } from '../../context/ThemeContext';
import NextArrow from '../../assets/Quiz/NextArrow.svg';
import NextArrowPng from '../../assets/Quiz/NextArrow.png';
import NextArrowDark from '../../assets/Quiz/NextArrowDark.svg';
import NextArrowHover from '../../assets/Quiz/NextArrowHover.svg';
import BackArrow from '../../assets/Quiz/BackArrow.svg';
import BackArrowDark from '../../assets/Quiz/Back Arrow Dark.svg';
import BackArrowPng from '../../assets/Quiz/BackArrow.png';
import '../../pages/ChildrenApplication/components/ChildrenApplication.css';
import '../../pages/Details/components/DetailsLayout.css';

const QuizNav = props => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const usePng = !isMacOS() && isFirefox() && !isDark;
  const backArrowSrc = isDark ? BackArrowDark : (usePng ? BackArrowPng : BackArrow);
  const nextArrowSrc = isDark ? NextArrowDark : (usePng ? NextArrowPng : NextArrow);

  return (
    <div className="d-flex navButtonsWrapper justify-content-between">
        <div >
          {props.showPrevious && <div onClick={props.previousQuestion} className="d-flex align-items-center backQ justify-content-end">
                <img  className="navImg" src={backArrowSrc} alt="" />
                <div className='cPointer prevQ'>Previous Question</div>
          </div>}
        </div>
      {props.showContinue && <div className={`d-flex align-items-center continueQ justify-content-start ${props.currentValueFullfilled() ? "enabled": "disabled"} questionI${props.currentQuestionI}`} onClick={props.nextQuestion}>
          <div className='cPointer font-weight-bold continue'>Continue</div>
          <span className="continue-arrow-icons"><img src={nextArrowSrc} className="navImg arrow-default cPointer" alt="" /><img src={NextArrowHover} className="navImg arrow-hover cPointer" alt="" /></span>
        </div>}
    </div>
  );
};

export default QuizNav;
